import * as Utils from './utils';

const navTrigger = document.querySelectorAll('.js-nav-trigger'),
    body = document.querySelector('body');
/**
* Nav Open/Close
**/
navTrigger.forEach(el => {
    el.addEventListener('click', e => {
        e.preventDefault();
        body.classList.toggle('open-nav');
    });
});

// Clicking on body when it has open nav class should
// close the nav pane down
// body.addEventListener('click', e => {
//     var $targetItem = e.target;

//     // Only run if the body DOESN'T have the open-nav class &&
//     // the thing clicked on ALSO ISN'T the js-nav-trigger
//     if (
//         body.classList.contains('open-nav') && !$targetItem.classList.contains('js-nav-trigger') && !$targetItem.parentElement.classList.contains('js-nav-trigger')
//     ) {
//         // If the $targetItem (or parent) isn't nav, close the nav pane
//         if (! $targetItem.closest('.js-nav').length) {
//             body.classList.remove('open-nav');
//         }
//     }
// });

/**
* Nav Sub-Nav Open/Close
**/
document.querySelectorAll('.js-show-sub-nav').forEach(el => {
    el.addEventListener('click', e => {
        e.preventDefault();

        var $navItem = el.closest('li'),
            $nav = document.querySelector('.js-nav'),
            alreadyOpen = ($navItem.classList.contains('open-sub-nav')) ? true : false;

        // Remove class 'open-sub-nav' from any list items that have it
        $nav.querySelectorAll('.open-sub-nav').forEach(el => {
            el.classList.remove('open-sub-nav');
            Utils.slideUp(el.querySelector('.js-nav-sub-nav'), 500);
        })

        // Add 'open-sub-nav' class to the clicked item and show the sub nav
        if (! alreadyOpen) {
            $navItem.classList.add('open-sub-nav');
            Utils.slideDown($navItem.querySelector('.js-nav-sub-nav'), 500);
        }
    });
});